import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Check, MessageCircle } from "lucide-react";
import { Reveal, SectionTag } from "./motion";
import { IMG, wa } from "../lib/site";

const features = [
  "Capacidade para até 18 passageiros",
  "Ideal para famílias e grupos de amigos",
  "Excursões, eventos e transfers",
  "Passeios turísticos pela Tríplice Fronteira",
];

export default function Transporte() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="transporte" ref={ref} className="relative overflow-hidden bg-brand-deep grain" data-testid="transporte-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <SectionTag dark>Transporte</SectionTag>
          <h2 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.08] text-balance">
            Conforto para você <span className="font-serif italic font-medium text-accent-soft">e seu grupo</span>
          </h2>
          <p className="mt-4 font-serif italic text-xl text-white/70">Viaje com quem conhece o caminho.</p>
          <p className="mt-6 text-white/75 text-base md:text-lg leading-relaxed">
            Nossa Sprinter possui capacidade para até 18 passageiros, sendo uma excelente opção para famílias, grupos de amigos, excursões, eventos, transfers e passeios turísticos.
          </p>
          <ul className="mt-8 space-y-3">
            {features.map((f) => (
              <li key={f} className="flex items-center gap-3 text-white/85 text-sm md:text-base">
                <span className="grid place-items-center w-6 h-6 rounded-full bg-whatsapp/20 shrink-0">
                  <Check size={13} className="text-whatsapp" strokeWidth={3} />
                </span>
                {f}
              </li>
            ))}
          </ul>
          <a
            href={wa("Olá, Magnus! Quero consultar a disponibilidade da Sprinter para meu grupo.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="transporte-cta-button"
            className="mt-10 inline-flex items-center gap-3 rounded-full bg-whatsapp px-9 py-4 text-sm font-bold text-white shadow-xl shadow-whatsapp/30 transition-transform duration-300 hover:scale-[1.04]"
          >
            <MessageCircle size={18} />
            Consultar disponibilidade
          </a>
        </Reveal>

        <Reveal delay={0.15}>
          <motion.div style={{ y }} className="relative">
            <div className="rounded-3xl overflow-hidden aspect-[4/3] shadow-2xl">
              <img src={IMG.van} alt="Sprinter do guia Magnus para até 18 passageiros em Foz do Iguaçu" className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="absolute -bottom-6 -left-4 md:-left-8 rounded-2xl bg-white px-6 py-4 shadow-2xl">
              <p className="font-display font-extrabold text-brand text-xl leading-none">Sprinter</p>
              <p className="text-xs text-moss mt-1">até 18 passageiros</p>
            </div>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
}
